import JobsService from 'top20common/distribution/services/jobs';
import commonUtils from 'top20common/distribution/utils';

export default {
  getRecommendedJobsListAction(context) {
    context.commit('mutateRecommendedJobsLoadingState', true);
    return context.dispatch('getRecommendedJobsListInBackgroundAction');
  },
  getRecommendedJobsListInBackgroundAction(context) {
    return new Promise((resolve, reject) => {
      JobsService.getRecommendedJobs()
        .then(response => {
          if (response.data.results) {
            context.commit('setPublishedRecommendedJobsListState', response.data.results);
          } else {
            context.commit('setPublishedRecommendedJobsListState', response.data.published);
            context.commit('setUnpublishedRecommendedJobsListState', response.data.other);
          }

          context.commit('mutateRecommendedJobsErrorState', null);
          resolve(typeof response.data === 'object' ? response.data : response.data.results);
        })
        .catch(error => {
          context.commit('mutateRecommendedJobsErrorState', commonUtils.getErrorMessageFromResponse(error.response));
        })
        .finally(function() {
          context.commit('mutateRecommendedJobsLoadingState', false);
        });
    });
  },
  reviewRecommendedJobAction(context, id) {
    return context.dispatch('updateRecommendedJobInBackgroundAction', {id, payload: {need_review: false}});
  },
  dismissRecommendedJobAction(context, id) {
    return context.dispatch('updateRecommendedJobInBackgroundAction', {id, payload: {dismissed: true}}).then(() => {
      context.commit('removeRecommendedJobFromList', id);
    });
  },
  dismissRecommendedJobActionByTime(context, {id, dismissTime = 400}) {
    context.commit('mutateRecommendedJob', {id: id, payload: {isHidden: true}});

    const startRequestTime = new Date().getTime();
    return context
      .dispatch('updateRecommendedJobInBackgroundAction', {id, payload: {dismissed: true}})
      .then(() => {
        const endRequestTime = new Date().getTime();
        let timeOfRequest = endRequestTime - startRequestTime;
        setTimeout(
          () => context.commit('removeRecommendedJobFromList', id),
          timeOfRequest < dismissTime ? dismissTime - timeOfRequest : 0
        );
      })
      .catch(() => {
        context.commit('mutateRecommendedJob', {id: id, payload: {isHidden: false}});
      });
  },
  interestedRecommendedJobAction(context, id) {
    return context.dispatch('updateRecommendedJobInBackgroundAction', {id, payload: {interested: true}}).then(() => {
      context.commit('mutateUnpublishedRecommendedJob', {id: id, payload: {interested: true}});
    });
  },
  updateRecommendedJobInBackgroundAction(context, {id, payload}) {
    return new Promise((resolve, reject) => {
      JobsService.updateRecommendedJob(id, payload)
        .then(response => {
          context.commit('mutateRecommendedJobsErrorState', null);
          resolve(response.data);
        })
        .catch(error => {
          context.commit('mutateRecommendedJobsErrorState', commonUtils.getErrorMessageFromResponse(error.response));
        });
    });
  }
};
